import { call, put, all, spawn, takeEvery } from 'redux-saga/effects';
import request from 'utils/request';
import { showToast } from 'containers/Toast/actions';
import {
  GET_DISPUTE_WALLET_BALANCE_URL,
  GET_DISPUTE_WALLET_STATUS_URL,
  UPDATE_DISPUTE_WALLET_URL,
} from 'containers/Wallets/constants';
import {
  ADD_MONEY_TO_FEE_WALLET_URL,
  ADD_MONEY_TO_WALLET,
  EXPORT_TO_CSV,
  FETCH_DISPUTE_WALLET_HISTORY_DATA_URL,
  FETCH_FEE_WALLET_HISTORY_DATA_URL,
  FETCH_WALLET_HISTORY_DATA,
  FETCH_WALLET_HISTORY_DATA_URL,
  GET_FEE_WALLET_STATUS_URL,
  GET_WALLET_BALANCE,
  GET_WALLET_BALANCE_URL,
  GET_WALLET_STATUS,
  MODIFY_WALLET_STATUS,
  MODIFY_WALLET_STATUS_URL,
} from './constants';
import {
  disableLoaderAction,
  updateBankDetailsAction,
  updateWalletBalanceAction,
  updateWalletStatusAction,
} from './actions';
import {
  getHeaderForTransactionsData,
  getModifiedTransactionsData,
} from './helpers';

import {
  GET_WALLET_STATUS_URL,
  ADD_MONEY_TO_WALLET_URL,
  ADD_MONEY_TO_DISPUTE_WALLET_URL,
} from '../../constants/url';

export function* getWalletStatus({ data: { walletType } }: any) {
  let { url: updatedUrl, method: updatedMethod } = GET_WALLET_STATUS_URL;
  switch (walletType) {
    case 'fee': {
      const { url, method } = GET_FEE_WALLET_STATUS_URL;
      updatedUrl = url;
      updatedMethod = method;
      break;
    }
    case 'dispute': {
      const { url, method } = GET_DISPUTE_WALLET_STATUS_URL;
      updatedUrl = url;
      updatedMethod = method;
      break;
    }
    default:
      break;
  }
  try {
    const response = yield call(request, updatedUrl, { updatedMethod });
    yield put(updateWalletStatusAction(response));
    yield put(disableLoaderAction());
  } catch (err) {
    yield put(disableLoaderAction());
    yield put(showToast(err));
  }
}

export function* getWalletBalance({ data: { walletType } }: any) {
  try {
    const { url, method } =
      walletType === 'dispute'
        ? GET_DISPUTE_WALLET_BALANCE_URL
        : GET_WALLET_BALANCE_URL;
    const response = yield call(request, url, { method });
    yield put(updateWalletBalanceAction(response));
    yield put(disableLoaderAction());
  } catch (err) {
    yield put(disableLoaderAction());
    yield put(showToast(err));
  }
}

export function* addMoneyToWallet({ data: { walletType } }: any) {
  try {
    let { url: updatedUrl, method: updatedMethod } = ADD_MONEY_TO_WALLET_URL;
    switch (walletType) {
      case 'fee': {
        const { url, method } = ADD_MONEY_TO_FEE_WALLET_URL;
        updatedUrl = url;
        updatedMethod = method;
        break;
      }
      case 'dispute': {
        const { url, method } = ADD_MONEY_TO_DISPUTE_WALLET_URL;
        updatedUrl = url;
        updatedMethod = method;
        break;
      }
      default:
        break;
    }
    const response = yield call(request, updatedUrl, { updatedMethod });
    const { vba, ifsc } = response;
    yield put(disableLoaderAction());
    yield put(updateBankDetailsAction({ vba, ifsc }));
  } catch (err) {
    yield put(disableLoaderAction());
    yield put(showToast(err));
  }
}

export function* modifyWalletStatus({ data }: any) {
  try {
    const { updatedBy, name, status, cb } = data;
    const { url, method } =
      name === 'dispute' ? UPDATE_DISPUTE_WALLET_URL : MODIFY_WALLET_STATUS_URL;
    const options = {
      method,
      body: JSON.stringify({ updatedBy, name, status }),
    };
    const response = yield call(request, url, options);
    if (cb) cb(response);
    yield put(disableLoaderAction());
  } catch (err) {
    yield put(disableLoaderAction());
    yield put(showToast(err));
  }
}

export function* fetchWalletsHistoryData({ data }: any) {
  try {
    const { options: reqOptions, cb, walletType } = data;
    let {
      url: updatedUrl,
      method: updatedMethod,
    } = FETCH_WALLET_HISTORY_DATA_URL;
    switch (walletType) {
      case 'fee': {
        const { url, method } = FETCH_FEE_WALLET_HISTORY_DATA_URL;
        updatedUrl = url;
        updatedMethod = method;
        break;
      }
      case 'dispute': {
        const { url, method } = FETCH_DISPUTE_WALLET_HISTORY_DATA_URL;
        updatedUrl = url;
        updatedMethod = method;
        break;
      }
      default:
        break;
    }
    const options = {
      updatedMethod,
      queryString: { ...reqOptions },
    };
    const response = yield call(request, updatedUrl, options);
    if (cb) cb(response);
    yield put(disableLoaderAction());
  } catch (err) {
    yield put(disableLoaderAction());
    yield put(showToast(err));
  }
}

export function* exportToCSV({ data }: any) {
  try {
    const { cb, options: reqOptions, feeWallet } = data;
    const { url, method } = feeWallet
      ? FETCH_FEE_WALLET_HISTORY_DATA_URL
      : FETCH_WALLET_HISTORY_DATA_URL;
    const options = {
      method,
      queryString: { ...reqOptions },
    };
    const responseData = yield call(request, url, options);
    const { content = [] } = responseData;
    const modifiedResponseData = getModifiedTransactionsData(content);
    const responseArr = [
      getHeaderForTransactionsData(modifiedResponseData),
      ...modifiedResponseData,
    ];
    const filename = feeWallet ? 'Fee Wallet.csv' : 'Refund Wallet.csv';
    cb(filename, responseArr);
    yield put(disableLoaderAction());
  } catch (err) {
    yield put(disableLoaderAction());
    yield put(showToast(err));
  }
}

export function* getWalletStatusSaga() {
  yield takeEvery(GET_WALLET_STATUS, getWalletStatus);
}

export function* getWalletBalanceSaga() {
  yield takeEvery(GET_WALLET_BALANCE, getWalletBalance);
}

export function* addMoneyToWalletSaga() {
  yield takeEvery(ADD_MONEY_TO_WALLET, addMoneyToWallet);
}

export function* modifyWalletStatusSaga() {
  yield takeEvery(MODIFY_WALLET_STATUS, modifyWalletStatus);
}

export function* exportToCSVSaga() {
  yield takeEvery(EXPORT_TO_CSV, exportToCSV);
}

export function* fetchWalletHistoryDataSaga() {
  yield takeEvery(FETCH_WALLET_HISTORY_DATA, fetchWalletsHistoryData);
}

// Individual exports for testing
export default function* walletDetailsPageSaga() {
  // See example in containers/HomePage/saga.js
  const sagas = [
    fetchWalletHistoryDataSaga,
    getWalletStatusSaga,
    getWalletBalanceSaga,
    addMoneyToWalletSaga,
    modifyWalletStatusSaga,
    exportToCSVSaga,
  ];

  yield all(
    sagas.map(saga =>
      // eslint-disable-next-line func-names, prettier/prettier
      spawn(function*() {
        while (true) {
          try {
            yield call(saga);
            break;
          } catch (e) {
            // eslint-disable-next-line no-console
            console.log(e);
          }
        }
      }),
    ),
  );
}
